import React from 'react';
import styled from 'styled-components';
import PermWrapper from '@/components/PermWrapper';
import PartitionLimiting from './PartitionLimiting';
import ResourceGroupLimiting from './ResourceGroupLimiting';

export default function Limting({ namespace, clusterName }) {
  return (
    <PermWrapper resource='pulsar:namespace:list:GEOPolice'>
      <Root>
        <ResourceGroupLimiting clusterName={clusterName} namespace={namespace} />
        <PartitionLimiting clusterName={clusterName} namespace={namespace} />
      </Root>
    </PermWrapper>
  );
}

const Root = styled.div`
  display: flex;
  gap: 12px;
  align-items: stretch;
`;
